interface UndoConfirmPopupProps {
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
  confirmLabel?: string;
  variant?: 'error' | 'warning';
}

export default function UndoConfirmPopup({
  onConfirm,
  onCancel,
  title = 'Confirm Undo',
  message = 'Are you sure you want to undo the last action?',
  confirmLabel = 'Yes, Undo',
  variant = 'warning',
}: UndoConfirmPopupProps) {
  const confirmColor = variant === 'error' ? 'bg-error' : 'bg-warning';
  const iconColor = variant === 'error' ? 'text-error' : 'text-warning';
  const iconBg = variant === 'error' ? 'bg-error/20' : 'bg-warning/20';

  return (
    <div className="fixed inset-0 bg-black/80 flex items-center justify-center p-4 z-50">
      <div className="bg-surface border border-border rounded-xl p-6 max-w-sm w-full animate-fade-in">
        <div className="text-center">
          <div className={`w-12 h-12 rounded-full ${iconBg} flex items-center justify-center mx-auto mb-4`}>
            <svg className={`w-6 h-6 ${iconColor}`} fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          <h2 className="text-xl font-bold text-text-primary mb-2">{title}</h2>
          <p className="text-text-secondary mb-6">{message}</p>
          <div className="space-y-3">
            <button
              onClick={onConfirm}
              className={`btn-primary ${confirmColor} text-white font-bold py-3 w-full`}
            >
              {confirmLabel}
            </button>
            <button
              onClick={onCancel}
              className="btn-secondary w-full"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
